import { C3GraphicCompatibleModel } from '../enums/c3-graphic-compatible-model.enum';
import { C3GraphicVersionStatus } from '../enums/c3-graphic-version-status.enum';
import { C3GraphicVersion } from '../models/c3-graphic-version.model';
import { C3ProductVersion } from '../models/c3-product-version.model';

const C3_MODEL_PREFIXES: Record<C3GraphicCompatibleModel, readonly string[]> = {
    [C3GraphicCompatibleModel.Pickup]: ['3000', '3010'],
    [C3GraphicCompatibleModel.Rover]: ['4000', '4010'],
    [C3GraphicCompatibleModel.CoolerTrailer]: ['4030'],
    [C3GraphicCompatibleModel.DeliveryTruck]: ['5000', '5010'],
    [C3GraphicCompatibleModel.Zamboni]: ['6000', '6010'],
    [C3GraphicCompatibleModel.Boat]: ['7000', '7010'],
};

const C3_MODEL_PREFIX_SET = new Set(Object.values(C3_MODEL_PREFIXES).flat());

/**
 * Graphic compatibility is catalog metadata, while current C3 products encode
 * their model in the part number. Resolve both vehicle names and explicit model
 * prefixes so order entry cannot offer artwork for a different cooler body.
 */
export function c3GraphicMatchesProduct(
    graphic: C3GraphicVersion,
    product: C3ProductVersion,
): boolean {
    const productPrefixes = extractModelPrefixes(product.partNumber);
    if (!productPrefixes.size || !graphic.modelCompatibility?.length) {
        return false;
    }

    return graphic.modelCompatibility.some((compatibility) =>
        C3_MODEL_PREFIXES[compatibility]?.some((prefix) => productPrefixes.has(prefix)),
    );
}

export function isC3GraphicOrderOption(graphic: C3GraphicVersion): boolean {
    return graphic.status === C3GraphicVersionStatus.Released && !!graphic.visibleToOrders;
}

function extractModelPrefixes(value: string): Set<string> {
    return new Set(
        [...String(value ?? '').matchAll(/\d{4}/g)]
            .map((match) => match[0])
            .filter((prefix) => C3_MODEL_PREFIX_SET.has(prefix)),
    );
}
